import { localisedValue } from "utils"

const countryTransformer = (response, nationalityFlag) => {
  if (!response) {
    return nationalityFlag ? { countries: [], nationalities: [] } : []
  }
  const countries = response.map(e => ({
    ...e,
    key: e?.id,
    label: localisedValue({ object: e, key: "name" }),
    value: e?.id?.toString(),
  }))

  if (nationalityFlag) {
    const nationalities = response.map(e => ({
      ...e,
      label: localisedValue({ object: e, key: "nationalityTitle" }),
      value: e?.id,
    }))

    return {
      countries,
      nationalities,
    }
  }

  return countries
}

export default countryTransformer
